import http from "@/utils/http";
//查询服务对象
export const queryMatterObjects= () => http.get('/nonlogin/serviceObject/queryServiceObjectList.htm');
//查询事项性质
export const queryMatterNatures= () => http.get('/nonlogin/transactWay/queryTransactWayList.htm');
//查询办理模式
export const queryMatterModels= () => http.get('/nonlogin/elobby/type/queryTypes.htm');
//查询部门机构
export const queryMatterDepts= () => http.get('/nonlogin/elobby/type/queryTypes.htm');
//查询服务
export const queryMatters= (params) => http.get('/nonlogin/serviceHandleCenter/queryServicesWithPageByCondition.htm',params);
//查询部门机构列表
export const queryMattersDepartments= (params) => http.get('/nonlogin/orgAndType/queryAllByTypeId.htm',params);
//查询事项清单
export const queryMobileItemListsData= (params) => http.get('/nonlogin/mobile/queryMobileItemListsData.htm',params);
//查询事项清单详情
export const queryMobileItemListDetail= (params) => http.get('/nonlogin/mobile/queryMobileItemListDetail.htm',params);
//查询职责清单详情
export const queryMobileResponsibilityData= (params) => http.get('/nonlogin/mobile/queryMobileResponsibilityData.htm',params);
